﻿import { Utility } from '../Utility.js';
export { TechnicianReport };

/**
 * Class RoadBuilderTool
 */
const TechnicianReport = function () {

    // Define this
    var myTechnicianReport = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Utility
    this._utility = new Utility();

    // Columns for citizen report list
    this._columnsCitizenReport = [
        {
            field: "buttonAction",
            title: " ",
            menu: false,
            command: [
                {
                    name: "EditCitizenReport",
                    template: '<a class="waves-effect edit-citizen-report" style="margin: 1px 5px 1px 2px;" title="Edição da ocorrência do cidadão"><i class= "material-icons">edit</i></a>'
                }],
            width: "5%"
        }, {
            field: "cod_report",
            title: "Identificador",
            groupable: false,
            filterable: { multi: false, search: true },
            sortable: false,
            menu: false,
            width: "10%"
        }, {
            field: "email",
            title: "Email",
            groupable: false,
            filterable: { multi: false, search: true },
            sortable: false,
            menu: false
        }, {
            field: "id_state",
            title: "Estado",
            groupable: false,
            filterable: { multi: false, search: true },
            sortable: false,
            menu: false,
            filterable: {
                ui: function (element) {
                    element.kendoDropDownList({
                        dataTextField: "decription",
                        dataValueField: "codRef",
                        dataSource: interfaceConfig.citizenReportStates,
                        optionLabel: "--Select Value--"
                    });
                }
            },
            template: ({ state }) => `<div style="text-align: center;"><div style="background-color: ${state.code_color};border-radius: 17px;padding: 5px 9px 5px 9px;display: inline;"><span style="font-size: 14px; font-weight: 800; border-radius: 25%">${state.decription}</span></div></div>`
        }, {
            field: "formattedDtProcess",
            title: "Data",
            groupable: false,
            filterable: { multi: false, search: true },
            sortable: false,
            menu: false
        }
    ];

    // Columns for technician report list
    this._columnsTechnicianReport = [
        {
            field: "buttonAction",
            title: " ",
            menu: false,
            command: [
                {
                    name: "EditTecnicianReport",
                    template: '<a class="waves-effect edit-technician-report" style="margin: 1px 5px 1px 2px;" title="Edição da ocorrência técnica"><i class= "material-icons">edit</i></a>'
                }],
            width: "5%"
        }, {
            field: "cod_report",
            title: "Identificador",
            groupable: false,
            filterable: { multi: false, search: true },
            sortable: false,
            menu: false,
            width: "10%"
        },  {
            field: "cod_state",
            title: "Estado",
            groupable: false,
            filterable: { multi: false, search: true },
            sortable: false,
            menu: false,
            filterable: {
                ui: function (element) {
                    element.kendoDropDownList({
                        dataTextField: "description",
                        dataValueField: "codRef",
                        dataSource: interfaceConfig.citizenReportStates,
                        optionLabel: "--Select Value--"
                    });
                }
            },
            template: ({ state }) => `<div style="text-align: center;"><div style="background-color: ${state.code_color};border-radius: 17px;padding: 5px 9px 5px 9px;display: inline;"><span style="font-size: 14px; font-weight: 800; border-radius: 25%">${state.description}</span></div></div>`
        }, {
            field: "formatted_dt_open",
            title: "Data de Abertura",
            groupable: false,
            filterable: { multi: false, search: true },
            sortable: false,
            menu: false
        }, {
            field: "formatted_dt_close",
            title: "Data de Fecho",
            groupable: false,
            filterable: { multi: false, search: true },
            sortable: false,
            menu: false
        }
    ];

    // For photo manager
    this._previewContainer = $('#id-detail-technician-report-preview-photo');
    this._previewCompoment = null;

    // Reference has
    this._hashReference = {};

    // Entity identifier active
    this._idEntityActive = null;

    // Array of layer info with technician report
    this._arrayLayerInfo = {};

    // -- end private variable --------------------------------------------------------------------


    // -- begin public variable -------------------------------------------------------------------

    // -- end public variable ---------------------------------------------------------------------


    // -- begin public method ---------------------------------------------------------------------

    /**
     * Build technician report information for a element
     * @param {string} idEntity
     * @param {string} layerName
     */
    this.BuildTechnicianReportEntity = function (idEntity, layerName) {

        myTechnicianReport._idEntityActive = idEntity;

        // -- List citizen report --
        const idGridCitizenReport = '#id-detail-technician-report-table-citizen-report';
        $('#id-detail-technician-report-edition-id-entity').val(idEntity);

        var gridCitizenReport = $(idGridCitizenReport).data("kendoGrid");
        if (gridCitizenReport) {
            $(idGridCitizenReport).data("kendoGrid").destroy();
            $(idGridCitizenReport).empty();
        }

        $(idGridCitizenReport).kendoGrid({
            noRecords: {
                template: '<div style="text-align:center;min-height:40px;width: 100%;align-content:center;"><span>Não existem resultados</span></div>'
            },
            columns: myTechnicianReport._columnsCitizenReport,
            dataSource: {
                // type: "json",
                transport: {
                    read: {
                        url: '/rest/app/TechnicianReport/GetAllCitizenReportFromEntity?idEntity=' + idEntity + "&layerName=" + layerName,
                        type: 'GET',
                        dataType: "json",
                    }
                },
                schema: {
                    data: function (response) {
                        if (response.result.status == 'SUCCESS') {
                            return response.result.listCitizenReport;
                        }
                        return [];
                    },
                    errors: function (response) {
                        if (response.result.status == 'ERROR') {
                            return "Erro na obtenção da informação das ocorrências dos cidadãos";
                        }
                        return null;
                    }
                },
                serverPaging: false,
                serverFiltering: false,
                serverSorting: false
            },
            //toolbar: [
            //    { template: '<button type="button" disabled id="id-button-list-select-signal" title="Adicionar sinal" class="btn btn-primary" style="padding-top: 8px; padding-bottom: 8px;"><i class= "fa fa-link"></i></button>' }
            //],
            pageable: false,
            filterable: false,
            scrollable: false,
            sortable: false,
            groupable: false,
            //pageable: {
            //    info: false,
            //    type: "numeric",
            //    previousNext: true,
            //    buttonCount: 2,
            //    input: false
            //}
        });

        // -- List technician report --
        const idGridTechnicianReport = '#id-detail-technician-report-table';

        var gridTechnicianReport = $(idGridTechnicianReport).data("kendoGrid");
        if (gridTechnicianReport) {
            $(idGridTechnicianReport).data("kendoGrid").destroy();
            $(idGridTechnicianReport).empty();
        }

        $(idGridTechnicianReport).kendoGrid({
            noRecords: {
                template: '<div style="text-align:center;min-height:40px;width: 100%;align-content:center;"><span>Não existem resultados</span></div>'
            },
            columns: myTechnicianReport._columnsTechnicianReport,
            dataSource: {
                // type: "json",
                transport: {
                    read: {
                        url: '/rest/app/TechnicianReport/GetAllTechnicianReportFromEntity?idEntity=' + idEntity,
                        type: 'GET',
                        dataType: "json",
                    }
                },
                schema: {
                    data: function (response) {
                        if (response.result.status == 'SUCCESS') {
                            return response.result.listTechnicianReport;
                        }
                        return [];
                    },
                    errors: function (response) {
                        if (response.result.status == 'ERROR') {
                            return "Erro na obtenção da informação das ocorrências técnicas";
                        }
                        return null;
                    }
                },
                serverPaging: false,
                serverFiltering: false,
                serverSorting: false
            },
            //toolbar: [
            //    { template: '<button type="button" disabled id="id-button-list-select-signal" title="Adicionar sinal" class="btn btn-primary" style="padding-top: 8px; padding-bottom: 8px;"><i class= "fa fa-link"></i></button>' }
            //],
            pageable: false,
            filterable: false,
            scrollable: false,
            sortable: false,
            groupable: false,
            //pageable: {
            //    info: false,
            //    type: "numeric",
            //    previousNext: true,
            //    buttonCount: 2,
            //    input: false
            //}
        });

        // -- Foto init --
        const offcanvasLayerDetail = $('#id-offcanvas-layer-detail');
        const fileInput = $('#id-detail-technician-report-input-photo');
        const photoButton = $('#id-detail-technician-report-btn-photo');
        const dropZone = $('#id-detail-technician-report-input-photo-dropZone');

        fileInput.val('');
        myTechnicianReport._previewContainer.empty();
        myTechnicianReport._previewContainer.css('display', 'none');

        let listFiles = [];

        if (myTechnicianReport._utility.mobilecheck()) {
            dropZone.hide();
            photoButton.show();
        } else {
            dropZone.show();
            photoButton.hide();
        }

        offcanvasLayerDetail.off().on('resize', () => {
            if (myTechnicianReport._previewCompoment) {
                myTechnicianReport._previewCompoment.refresh();
            }
        });

        photoButton.off().on('click', () => {
            fileInput.click();
        });

        fileInput.off().on('change', event => {
            for (var i = 0; i < event.target.files.length; i++) {
                listFiles.push(event.target.files[i]);
            }
            myTechnicianReport._handleFiles(listFiles);
        });

        dropZone.off();

        dropZone.on('click', () => {
            fileInput[0].click();
        });

        dropZone.on('dragover', event => {
            event.preventDefault();
            dropZone.addClass('dragover');
        });

        dropZone.on('dragleave', () => {
            dropZone.removeClass('dragover');
        });

        dropZone.on('drop', event => {
            event.preventDefault();
            dropZone.removeClass('dragover');

            for (let i = 0; i < event.originalEvent.dataTransfer.files.length; i++) {
                listFiles.push(event.originalEvent.dataTransfer.files[i]);
            }
            myTechnicianReport._handleFiles(listFiles);
        });
    };

    // -- end public method -----------------------------------------------------------------------


    // -- begin private method --------------------------------------------------------------------

    /**
     * Init technician report information for a element
     * @param {any} idElement
     */
    this._InitTechnicianReportElement = function (idElement) {

        // Build 
    };

    /**
     * Handle files
     * @param {any} files
     */
    this._handleFiles = function(files) {

        let indexImage = 0;
        myTechnicianReport._previewContainer.empty();

        Array.from(files).forEach(file => {
            if (file && file.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.onload = e => {

                    indexImage++;

                    const divImage = document.createElement("div");

                    divImage.className = "photo";
                    divImage.style.backgroundImage = `url('${e.target.result}')`;
                    divImage.setAttribute("data-role", "page");

                    const deleteButton = document.createElement('button');
                    deleteButton.textContent = 'X';
                    deleteButton.classList.add('delete-button');
                    deleteButton.addEventListener('click', (event) => {
                        $(event.target).parent().remove();
                        for (var i = 0; i < listFiles.length; i++) {
                            if (file.name == listFiles[i].name) {
                                listFiles.splice(i, 1);
                                myTechnicianReport._previewCompoment.refresh();
                                myTechnicianReport._previewCompoment.prev();

                                if (listFiles.length == 0) {
                                    previewContainer.css('display', 'none');
                                }
                                break;
                            }
                        }
                    });

                    divImage.appendChild(deleteButton);
                    myTechnicianReport._previewContainer.append(divImage);

                    if (indexImage == files.length) {
                        myTechnicianReport._previewContainer.css('display', 'block');

                        myTechnicianReport._previewCompoment = myTechnicianReport._previewContainer.kendoScrollView({
                            contentHeight: "245px",
                            enablePager: true
                        }).data("kendoScrollView");
                    }
                };
                reader.readAsDataURL(file);
            }
        });
    }

    /**
     * Get all reference for technician report
     */
    this._GetTechnicianReportReference = function () {
        $.ajax({
            type: 'GET',
            url: '/rest/app/TechnicianReport/GetAllTechnicianReportReference',
            async: false,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da informação de referência das ocorrências técnicas");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            myTechnicianReport._hashReference = {
                                "list_ref_state": data.result.listReferenceState,
                                "list_ref_priority": data.result.listReferencePriority,
                                "list_ref_type": data.result.listReferenceType
                            };
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na obtenção da informação de referência das ocorrências técnicas");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da informação de referência das ocorrências técnicas");
            }
        });
    }

    // -- end private method ----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    /**
     * Event view form for create new technician report
     */
    $('#id-detail-technician-report-create').off('click').on('click', function (e) {
        $('#id-detail-technician-report-edition-zone').show();
        $('#id-detail-technician-report-edition-zone .sub-tab-content').addClass('for-creation');
        $('#id-detail-technician-report-edition-zone .create-not-use').hide();
        $('#id-detail-technician-report-save').attr("mode", "create");
        $('#id-detail-technician-report-save').attr("title", "Criar nova ocorrência técnica");
        $('#id-detail-technician-report-edition-title').html("Nova Ocorrências Técnicas");
    });

    /**
     * Event save technician report
     */
    $('#id-detail-technician-report-save').off('click').on('click', function (e) {
        switch ($(this).attr("mode")) {
            case "create":
                var technicianReportInfo = $('#id-detail-technician-report-edition-form').serializeJSON();
                $.ajax({
                    type: 'POST',
                    url: '/rest/app/TerritorialManagement/SaveTechnicianReport',
                    contentType: "application/json",
                    dataType: 'json',
                    data: JSON.stringify(technicianReportInfo),
                    async: true,
                    success: function (data) {
                        if (data.error) {
                            toastr["error"]("Erro na criação de uma ocorrência técnica");
                        }
                        else {
                            switch (data.result.status) {
                                case 'SUCCESS':
                                    toastr["success"]("Ocorrência técnica criada com sucesso");
                                    // Close form create
                                    $('#id-detail-technician-report-edition-zone').hide();
                                    // Reload table technician report
                                    myTechnicianReport.BuildTechnicianReportEntity(myTechnicianReport._idEntityActive);
                                    break;
                                case 'ERROR':
                                    toastr["error"]("Erro na criação de uma ocorrência técnica");
                                    break;
                                default:
                            }
                        }
                    },
                    error: function (request, status, error) {
                        toastr["error"]("Erro na criação de uma ocorrência técnica");
                    }
                });

                breack;
            case "edition":
                break;
            default:
                // do nothing
        }
    });

    $('#id-detail-technician-report-close').off('click').on('click', function (e) {
        $('#id-detail-technician-report-edition-zone').hide();
    });

    // -- end event -------------------------------------------------------------------------------
};

/**
* Init technician report
* @param {object} mapSgs, map object
*/
TechnicianReport.prototype.Init = function (mapSgs) {

    // Set map info
    this._mapSgs = mapSgs;

    // Get all reference for technician report
    this._GetTechnicianReportReference();

    // Fill Combo box of the technician report
    this._utility.FillSelect('id-detail-technician-report-edition-cod-state', this._hashReference["list_ref_state"], "description", "cod_ref");
    this._utility.FillSelect('id-detail-technician-report-edition-cod-priority', this._hashReference["list_ref_priority"], "description", "cod_ref");
    this._utility.FillSelect('id-detail-technician-report-edition-id-type', this._hashReference["list_ref_type"], "description", "id");

    // Get layer info
    var layerInfoObj = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TECHNICIAN_REPORT", "CONFIG", "LAYER_INFO");
    if (layerInfoObj && layerInfoObj.value) {
        this._arrayLayerInfo = JSON.parse(layerInfoObj.value);
    }
};